import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { Auth, retrieveToken, retrieveTokenDev } from "../../utils/auth/Auth";
import { ContextProvider } from "../contextProvider/ContextProvider";
import { IS_DEV } from "../../utils/auth/config";

let authMounted = false;

const PrivateRoute = () => {
    const { userName } = useParams();

    const [token, setToken] = useState(null);

    /**
     * username is strictly a development var
     */
    useEffect(() => {
        if (userName && IS_DEV) {
            retrieveTokenDev(0, userName).then((response) => {
                setToken(response);
            });
        } else if (IS_DEV && sessionStorage.getItem("devLogin") === "devLogin") {
            retrieveTokenDev(0, null).then((response) => {
                setToken(response);
            });
        } else {
            retrieveToken().then((response) => {
                setToken(response);
            });
        }
    }, [userName]);

    const [renderAuth, setRenderAuth] = useState(false);

    useEffect(() => {
        if (!authMounted) {
            authMounted = true;
            setRenderAuth(true);
        }
        return () => {
            if (renderAuth) {
                authMounted = false;
            }
        };
    }, [renderAuth]);

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    if (!token) {
        return renderAuth ? <Auth /> : null;
    }

    return (
        <ContextProvider>
            <Outlet />
            {renderAuth && <Auth />}
        </ContextProvider>
    );
};

export default PrivateRoute;
